export enum PointAwardingType {
  EXHIBITION = '0 points exhibition match',
  MATCH = '1 point for each match won',
  COLLECTION = '1 point for winning more matches in collection',
  SCORE = '1 point for each game won',
  SET = '1 point for each set won',
}

export const pointAwardingTypes = [
  {
    description: PointAwardingType.EXHIBITION,
    key: 'EXHIBITION',
  },
  {
    description: PointAwardingType.MATCH,
    key: 'MATCH',
  },
  {
    description: PointAwardingType.COLLECTION,
    key: 'COLLECTION',
  },
  {
    description: PointAwardingType.SCORE,
    key: 'SCORE',
  },
  {
    description: PointAwardingType.SET,
    key: 'SET',
  },
];

export const parsePointAwardingType = ({
  matchUpValue,
  collectionValue,
  scoreValue,
  setValue,
}: {
  matchUpValue?: number;
  collectionValue?: number;
  scoreValue?: number;
  setValue?: number;
}) => {
  if (matchUpValue === 0) return PointAwardingType.EXHIBITION;
  if (matchUpValue) return PointAwardingType.MATCH;
  if (collectionValue) return PointAwardingType.COLLECTION;
  if (scoreValue) return PointAwardingType.SCORE;
  if (setValue) return PointAwardingType.SET;
  return undefined;
};
